module.exports = __webpack_public_path__ + "static/img/view_restriction.4852a7ec.png";